import { render, staticRenderFns } from "./ContentSelection.vue?vue&type=template&id=1acb1bb6"
import script from "./ContentSelection.vue?vue&type=script&lang=js"
export * from "./ContentSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports